"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SpotLight_angle, _SpotLight_decay, _SpotLight_distance, _SpotLight_penumbra, _SpotLight_position, _SpotLight_target;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpotLight = void 0;
const gl_matrix_1 = require("gl-matrix");
const ILight_1 = require("../../interface/ILight");
const AbstractLight_1 = require("../AbstractLight");
class SpotLight extends AbstractLight_1.AbstractLight {
    // #endregion Properties (6)
    // #region Constructors (1)
    constructor(properties) {
        super({
            color: properties.color || "#ffffff",
            intensity: properties.intensity !== undefined ? properties.intensity : 1,
            type: ILight_1.LIGHT_TYPE.SPOT,
            name: properties.name,
            order: properties.order,
            id: properties.id,
            version: properties.version,
        });
        // #region Properties (6)
        _SpotLight_angle.set(this, Math.PI / 4.0);
        _SpotLight_decay.set(this, 0);
        _SpotLight_distance.set(this, 0);
        _SpotLight_penumbra.set(this, 0.5);
        _SpotLight_position.set(this, gl_matrix_1.vec3.fromValues(-1, 0, 1));
        _SpotLight_target.set(this, gl_matrix_1.vec3.fromValues(0, 0, 0));
        if (properties.position)
            __classPrivateFieldSet(this, _SpotLight_position, properties.position, "f");
        if (properties.target)
            __classPrivateFieldSet(this, _SpotLight_target, properties.target, "f");
        if (properties.distance)
            __classPrivateFieldSet(this, _SpotLight_distance, properties.distance, "f");
        if (properties.decay)
            __classPrivateFieldSet(this, _SpotLight_decay, properties.decay, "f");
        if (properties.angle)
            __classPrivateFieldSet(this, _SpotLight_angle, properties.angle, "f");
        if (properties.penumbra)
            __classPrivateFieldSet(this, _SpotLight_penumbra, properties.penumbra, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (12)
    get angle() {
        return __classPrivateFieldGet(this, _SpotLight_angle, "f");
    }
    set angle(value) {
        __classPrivateFieldSet(this, _SpotLight_angle, value, "f");
        this.updateVersion();
        if (this.parentNode)
            this.parentNode.updateVersion();
    }
    get decay() {
        return __classPrivateFieldGet(this, _SpotLight_decay, "f");
    }
    set decay(value) {
        __classPrivateFieldSet(this, _SpotLight_decay, value, "f");
        this.updateVersion();
        if (this.parentNode)
            this.parentNode.updateVersion();
    }
    get distance() {
        return __classPrivateFieldGet(this, _SpotLight_distance, "f");
    }
    set distance(value) {
        __classPrivateFieldSet(this, _SpotLight_distance, value, "f");
        this.updateVersion();
        if (this.parentNode)
            this.parentNode.updateVersion();
    }
    get penumbra() {
        return __classPrivateFieldGet(this, _SpotLight_penumbra, "f");
    }
    set penumbra(value) {
        __classPrivateFieldSet(this, _SpotLight_penumbra, value, "f");
        this.updateVersion();
        if (this.parentNode)
            this.parentNode.updateVersion();
    }
    get position() {
        return __classPrivateFieldGet(this, _SpotLight_position, "f");
    }
    set position(value) {
        __classPrivateFieldSet(this, _SpotLight_position, value, "f");
        this.updateVersion();
        if (this.parentNode)
            this.parentNode.updateVersion();
    }
    get target() {
        return __classPrivateFieldGet(this, _SpotLight_target, "f");
    }
    set target(value) {
        __classPrivateFieldSet(this, _SpotLight_target, value, "f");
        this.updateVersion();
        if (this.parentNode)
            this.parentNode.updateVersion();
    }
    // #endregion Public Getters And Setters (12)
    // #region Public Methods (1)
    clone() {
        return new SpotLight({
            color: this.color,
            position: this.position,
            target: this.target,
            distance: this.distance,
            decay: this.decay,
            angle: this.angle,
            penumbra: this.penumbra,
            intensity: this.intensity,
            name: this.name,
            order: this.order,
            id: this.id,
            version: this.version,
        });
    }
}
exports.SpotLight = SpotLight;
_SpotLight_angle = new WeakMap(), _SpotLight_decay = new WeakMap(), _SpotLight_distance = new WeakMap(), _SpotLight_penumbra = new WeakMap(), _SpotLight_position = new WeakMap(), _SpotLight_target = new WeakMap();
//# sourceMappingURL=SpotLight.js.map